module.exports = __webpack_public_path__ + "img/2.59fc8598.png";